module.exports = __webpack_public_path__ + "img/pubg.7a3651b.jpg";